import { Link } from 'react-router-dom';
import Breadcrumb from '../components/Breadcrumb';
import TitlePage from '../components/TitlePage';

const Team = () => {
    return (
        <>
            <Breadcrumb history={[{ title: 'Home', to: '/' }]} current='Team' />

            <section id='about' className='about'>
                <TitlePage title='Team' />

                <div className='container'>
                    <div className='row gy-4'>
                        <div className='col-lg-6 content text-center' data-aos='fade-up' data-aos-delay='100'>
                            <img src={'img/team/about.webp'} width='90%' className='img-fluid' alt='Il nostro team' />
                        </div>

                        <div className='col-lg-6' data-aos='fade-up' data-aos-delay='200'>
                            <p>La nostra realtà, nata nel 2023, si pone come obiettivi:</p>
                            <ul>
                                <li>
                                    <i className='bi bi-check2-circle'></i>
                                    <span>
                                        Diventare un polo di riferimento, orientamento e osservazione per tutti coloro che vogliono
                                        intraprendere una carriera nel mondo della moda;
                                    </span>
                                </li>
                                <li>
                                    <i className='bi bi-check2-circle'></i>
                                    <span>Offrire servizi di consulenza e ricerca dei vari profili professionali.</span>
                                </li>
                            </ul>
                            <p>
                                La nostra community può contare su tantissime figure professionali come: modelli/modelle, fotografi/e,
                                stylist, MUA, fashion designers, art directors, trend forecasters, addetti stampa, brand manager e HR.
                                <br />
                            </p>
                            <p>Il nostro desiderio è riuscire a portare questo progetto, insieme al Made in Italy, anche all’estero.</p>
                            <Link to='/contact' className='read-more mt-3'>
                                <span>Contattaci</span>
                                <i className='bi bi-arrow-right'></i>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className='team'>
                <div className='container'>
                    <div className='container section-title' data-aos='fade-up'>
                        <h2>Team</h2>
                    </div>

                    <div className='row gy-4'>
                        <div className='col-lg-6' data-aos='fade-up' data-aos-delay='100'>
                            <div className='team-member d-flex align-items-start'>
                                <div className='pic'>
                                    <img src={'img/team/alessandra.webp'} className='img-fluid' alt='profilo Alessandra' />
                                </div>
                                <div className='member-info'>
                                    <h4>Alessandra</h4>
                                    <span>CFO</span>
                                    <p>
                                        Classe '02, si appassiona al mondo della moda sin da piccola sognando di viaggiare per il mondo in
                                        veste di stilista.
                                        <br />
                                        A 19 anni le idee cambiano, il mondo della moda fa sempre parte di lei mutando forma, spingendola a
                                        viaggiare per il mondo organizzando eventi per i stilisti internazionali.
                                        <br />
                                        Nel 2022 inizia la sua esperienza nei backstage della Fashion Week di Milano per poi arrivare alla
                                        Fashion Week di New York dove ha lavorato come capo vestierista e coordinatrice.
                                        <br />
                                        La passione per l’organizzazione di eventi unita all’esperienza nei backstage l’ha portata a fondare
                                        GLAMI Inside Fashion affinché studenti giovani e ambiziosi come lei possano vivere la sua stessa
                                        esperienza e costruirsi il proprio futuro fin da subito.
                                    </p>
                                    <div className='social'>
                                        <a
                                            href='https://www.linkedin.com/in/alessandra-bellantonio-072976234'
                                            target='_blank'
                                            rel='noreferrer'
                                        >
                                            <i className='bi bi-linkedin'></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-6' data-aos='fade-up' data-aos-delay='200'>
                            <div className='team-member d-flex align-items-start'>
                                <div className='pic'>
                                    <img src={'img/team/ludovica.webp'} className='img-fluid' alt='profilo Ludovica' />
                                </div>
                                <div className='member-info'>
                                    <h4>Ludovica</h4>
                                    <span>CEO</span>
                                    <p>
                                        Classe '94 si avvicina al mondo della moda nel 2014: dopo il diploma scolastico, frequenta
                                        l’accademia di Haute Couture Ida Ferri, specializzandosi in Fashion Designer.
                                        <br />
                                        Subito dopo, sempre a Roma, si diploma come modellista prototipista, per poi volare negli Stati
                                        Uniti dove inizia a collaborare nei backstage della Fashion Week di New York.
                                        <br />
                                        Nel 2019 lavora per un breve periodo in un noto atelier di Amsterdam collaborando alla realizzazione
                                        dello show per la Fashion Week di Parigi. Nel febbraio 2020 partecipa alla manifestazione di
                                        AltaRoma Altamoda con un suo abito “Imago Onirica”..
                                        <br />.<br />
                                        La sua esperienza quinquennale nei backstage di Milano, Roma, New York e Parigi, le ha permesso di
                                        assistere molti brand famosi…Ora si occupa di ufficio stile come Fashion Designer ma la sua passione
                                        per i Backstage continua a chiamarla e la sua voglia di condividere il suo sapere e la sua
                                        esperienza, l’ha portata a fondare GLAMI Inside Fashion!
                                    </p>
                                    <div className='social'>
                                        <a href='https://www.linkedin.com/in/ludovica-fares-797052137' target='_blank' rel='noreferrer'>
                                            <i className='bi bi-linkedin'></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-6' data-aos='fade-up' data-aos-delay='100'>
                            <div className='team-member d-flex align-items-start'>
                                <div className='pic'>
                                    <img src={'img/team/giulia.webp'} className='img-fluid' alt='profilo Giulia' />
                                </div>
                                <div className='member-info'>
                                    <h4>Giulia</h4>
                                    <span>SOCIAL MEDIA MANAGER</span>
                                    <p>
                                        Classe '99, nata e cresciuta a Firenze, dove ha conseguito, nel 2022, la laurea triennale in Design,
                                        presso l’ISIA di Firenze.
                                        <br />
                                        Attualmente frequenta il secondo anno di laurea magistrale in Design, Comunicazione Visiva e
                                        Multimediale all’Università Sapienza di Roma.
                                        <br />
                                        Da sempre appassionata di arte, in tutte le sue forme, nel corso degli anni ha sviluppato anche un
                                        grande interesse per la comunicazione digitale, in particolare attraverso i social media,
                                        approfondendo la materia tramite corsi e seminari.
                                        <br />
                                        Dal 2023 collabora con Glami Inside Fashion come grafica e social media manager, con la quale ha
                                        partecipato alla Milano e Parigi Fashion Week.
                                    </p>
                                    <div className='social'>
                                        <a href='https://www.linkedin.com/in/giulia-biagini-529969313' target='_blank' rel='noreferrer'>
                                            <i className='bi bi-linkedin'></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-6' data-aos='fade-up' data-aos-delay='200'>
                            <div className='team-member d-flex align-items-start'>
                                <div className='pic'>
                                    <img src={'img/team/marco.webp'} className='img-fluid' alt='profilo Marco' />
                                </div>
                                <div className='member-info'>
                                    <h4>Marco</h4>
                                    <span>MARKETING MANAGER</span>
                                    <p>
                                        Classe '01, da ormai 3 anni adottato da Roma ma con il cuore in Puglia.
                                        <br />
                                        Vive con l’amore per il marketing e si laurea in Comunicazione d’impresa.
                                        <br />
                                        Tra diverse organizzazioni di eventi , entra anche nel mondo del planning.
                                        <br />
                                        Occuperà il ruolo di Marketing Manager e di tutto ciò che riguarda gli eventi.
                                    </p>
                                    <div className='social'>
                                        <a href='https://www.linkedin.com/in/marco-de-santis-58ba20238' target='_blank' rel='noreferrer'>
                                            <i className='bi bi-linkedin'></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
export default Team;
